import styled from "@emotion/styled";

export const LandingButton = styled.button`
  background-color: ${({ bgColor }) => bgColor || "grey"};
  color: ${({ textColor }) => textColor || "white"};
  height: clamp(35px, 5vw, 55px);
  width: clamp(120px, 20vw, 220px);
  padding: clamp(8px, 1.5vw, 14px) clamp(16px, 2vw, 28px); 
  border: 0.5px solid grey;
  border-radius: clamp(5px, 1vw, 10px);
  cursor: pointer;
  font-weight: 600;
  font-size: clamp(14px, 1.2vw, 18px);
  transition: all 0.3s ease;

  &:hover {
    opacity: 0.9;
  }
`;
